import { jsx as e, Fragment as g } from "react/jsx-runtime";
import { useRef as R } from "react";
import { createPortal as w } from "react-dom";
import { useClickOutside as L } from "../../../../hooks/useClickOutside/index.js";
import { getRootScrollY as O } from "../../../../services/dom/index.js";
import { useDropdownContext as C } from "../../../../contexts/Dropdown/context.js";
import { ContainerVars as t, Container as T } from "./style.js";
import { dropdownListMobileAsideStyle as j, dropdownListMobileCenterStyle as z, dropdownListMobileFullPageStyle as G, dropdownListMobileOpenBottomStyle as H } from "./style.js";
import { DarkThemeWrapper as D } from "../../../../styles/themes/DarkThemeWrapper.js";
import { getOrCreatePortalElement as b } from "../../../../services/runtime/index.js";
import { useRerenderOnWindowResize as x } from "../../../../hooks/useRerenderOnWindowResize/index.js";
import { DROPDOWN_PORTAL_ID as y } from "../../consts.js";
var S = /* @__PURE__ */ ((r) => (r.LEFT = "left", r.RIGHT = "right", r))(S || {});
function v({
  children: r,
  side: n = "left",
  fixed: i,
  omitBreathingSpace: s,
  isThemeWrapperActive: d,
  ...m
}) {
  const { isOpen: f, closeDropdown: c, triggerRef: o } = C(), l = R(null);
  if (L([o, l], c), x(), !f || !o.current)
    return null;
  const p = o.current.getBoundingClientRect(), u = 16, a = {
    ...m.style || {},
    [t.TOP]: `${p.bottom + (s ? 0 : u) + (i ? 0 : O())}px`,
    [t.LEFT]: `${p[n]}px`,
    [t.TRANSLATE_X]: n === "right" ? "-100%" : "0"
  };
  return /* @__PURE__ */ e(g, { children: w(
    /* @__PURE__ */ e(D, { isActive: d, children: /* @__PURE__ */ e(
      T,
      {
        id: "dropdown-menu",
        role: "menu",
        ref: l,
        $fixed: i,
        ...m,
        style: a,
        children: r
      }
    ) }, 0),
    b(y)
  ) });
}
export {
  v as DropdownList,
  T as DropdownListContainer,
  S as DropdownListSide,
  j as dropdownListMobileAsideStyle,
  z as dropdownListMobileCenterStyle,
  G as dropdownListMobileFullPageStyle,
  H as dropdownListMobileOpenBottomStyle
};
